import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import {
  DriverItem,
  DriversGroupItem,
  DriversGroupsList,
  DriversList,
} from '../app/portal/pages/drivers/drivers.types';

@Injectable({
  providedIn: 'root',
})
export class DriversService {
  private readonly httpClient = inject(HttpClient);

  createDriver(form: any): Observable<DriverItem> {
    return this.httpClient.post<DriverItem>('drivers/', form);
  }

  createDriversGroup(form: any): Observable<DriversGroupItem> {
    return this.httpClient.post<DriversGroupItem>('drivers/groups/', form);
  }

  updateDriver(form: any, driverId: number): Observable<DriverItem> {
    return this.httpClient.put<DriverItem>(`drivers/${driverId}/`, form);
  }

  updateDriversGroup(form: any, driverId: number): Observable<DriversGroupItem> {
    return this.httpClient.put<DriversGroupItem>(`drivers/groups/${driverId}/`, form);
  }

  assignDriver(objectId: number, driverId: number) {
    return this.httpClient.post(`driver/attach/`, { driverId, objectId });
  }

  deAttachDriver(driverId: number) {
    return this.httpClient.post(`driver/deattach/`, { driverId });
  }

  appointmentHistory(driverId: number) {
    return this.httpClient.get(`driver/history/${driverId}/`);
  }

  driversList(): Observable<DriversList> {
    return this.httpClient.get<DriversList>('drivers/');
  }

  driversGroupList(): Observable<DriversGroupsList> {
    return this.httpClient.get<DriversGroupsList>('drivers/groups/');
  }

  deleteDriver(driverId: number) {
    return this.httpClient.delete(`drivers/${driverId}`);
  }

  deleteGroupDrivers(driverId: number) {
    return this.httpClient.delete(`drivers/groups/${driverId}`);
  }
}
